import styled from 'styled-components';
import { Div, ColumnDiv } from 'styles/elements/div';
import Input from 'styles/elements/input';
import { Label as L, HelpLabel } from 'styles/elements/label';
import media from 'styles/media';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';
import { Error } from 'styles/blocks/error';

// position: relative used here to absolutely position date-picker in relation to parent necessary for IE9.
const InputContainer = styled(ColumnDiv)`
  flex: 1;
  margin-right: 20px;
  min-width: 140px;
  position: relative;
  input[type="number"] {
    width: auto;
  }
  ${media.extraSmallAndBelow`
    margin-right: 8px;
  `};
`;

const Label = styled(L)`
  margin: 5px 0;
`;

const AddButton = styled(SecondaryButton)`
  border: none;
  text-decoration: underline;
  padding: 5px 0;
`;

const FieldsContainer = styled(Div)`
  padding: 0 0 15px;
  ${media.extraSmall`
    flex-direction: column;
  `}
  ${media.extraExtraSmall`
    flex-direction: column;
  `}
  ${media.extraSmallAndBelow`
    flex-direction: column;
  `};
`;

const FieldsContextWrapper = styled(Div)`
  flex: 1;
`;

const FieldsContainerOuter = styled(ColumnDiv)`
  background: ${props => (props.removable ? props.theme.brandingPrimaryShadeEight : 'white')};
  margin-left: -20px;
  padding-left: 20px;
  margin-right: -20px;
  padding-right: 20px;
`;

const RemoveButton = styled(SecondaryButton)`
  border: none;
  align-self: flex-end;
  margin-right: 20px;
  margin-bottom: 0;
  background: none;
`;

const BloodPressureInput = styled(Input)`
  width: calc(100% - 20px);
  &::-ms-clear {
    display: none;
  }
`;

const BloodPressureHelpLabel = styled(HelpLabel)`
  margin: 0.6em 0;
  padding: 5px 0;
`;

const BloodPressureError = styled(Error)`
  margin-right: 20px;
  ${media.extraSmallAndBelow`
    margin-right: 8px;
  `}
`;

const BloodPressure = styled(ColumnDiv)``;

BloodPressure.Input = BloodPressureInput;
BloodPressure.Label = Label;
BloodPressure.InputContainer = InputContainer;
BloodPressure.RemoveButton = RemoveButton;
BloodPressure.AddButton = AddButton;
BloodPressure.FieldsContainer = FieldsContainer;
BloodPressure.FieldsContextWrapper = FieldsContextWrapper;
BloodPressure.FieldsContainerOuter = FieldsContainerOuter;
BloodPressure.HelpLabel = BloodPressureHelpLabel;
BloodPressure.Error = BloodPressureError;

export default BloodPressure;
